var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-checkbox-group",
    {
      staticClass: "exam-checkbox-radio-box",
      attrs: { disabled: _vm.readOnly },
      on: { change: _vm.handleCheck },
      model: {
        value: _vm.checkValue[_vm.subjects.examQuestionsId],
        callback: function ($$v) {
          _vm.$set(_vm.checkValue, _vm.subjects.examQuestionsId, $$v)
        },
        expression: "checkValue[subjects.examQuestionsId]",
      },
    },
    _vm._l(_vm.subjects.options, function (item, index) {
      return _c(
        "el-checkbox",
        {
          key: item.examQuestionsOptionsId,
          attrs: { label: item.examQuestionsOptionsId + "[-]" + item.name },
        },
        [
          _c("span", [
            _vm._v(" " + _vm._s(item.option) + "." + _vm._s(item.name) + " "),
            item.imgs
              ? _c(
                  "div",
                  { staticClass: "img" },
                  [
                    _vm._l(item.imgs, function (img, i) {
                      return [
                        _c(
                          "el-popover",
                          {
                            key: i,
                            attrs: {
                              placement: "right",
                              trigger: "hover",
                              width: "200",
                              "popper-options": {
                                boundariesElement: "viewport",
                                removeOnDestroy: true,
                              },
                            },
                          },
                          [
                            _c(
                              "el-image",
                              {
                                attrs: {
                                  src: _vm.dsf.url.getWebPath(_vm.optionImg),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "image-slot",
                                    attrs: { slot: "error" },
                                    slot: "error",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-tupianjiazaishibai err-img",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "el-image",
                              {
                                key: i,
                                attrs: {
                                  slot: "reference",
                                  src: _vm.dsf.url.getWebPath(img.relativePath),
                                },
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.showPopver($event, index)
                                  },
                                  click: function ($event) {
                                    return _vm.showImage(item)
                                  },
                                },
                                slot: "reference",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "image-slot",
                                    attrs: { slot: "error" },
                                    slot: "error",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-tupianjiazaishibai err-img",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _c("i", {
            class: [
              "iconfont right-icon",
              _vm.previewStatus && _vm.readOnly && _vm.subjects.result
                ? _vm.subjects.result.indexOf(item.examQuestionsOptionsId) > -1
                  ? _vm.subjects.answer.indexOf(item.examQuestionsOptionsId) >
                    -1
                    ? "icon-icon_gou"
                    : "icon-icon_wrong"
                  : ""
                : "icon-icon_gou",
            ],
          }),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }